import React, { useState } from "react";
import { Modal, ModalBody, ModalHeader } from "reactstrap";

/**
 * IgStoryPopup — lightbox untuk melihat media story Instagram.
 *
 * Props:
 *   isOpen: boolean
 *   onClose: function()
 *   url: string — URL media story (bisa expired)
 *   mediaType: "image" | "video" — jenis media (default "image" untuk data lama)
 *   label: string — "Story Reply" | "Story Mention"
 */
const IgStoryPopup = ({ isOpen, onClose, url, mediaType, label }) => {
  const [mediaError, setMediaError] = useState(false);

  const handleOpen = () => setMediaError(false);
  const isVideo = mediaType === "video";

  return (
    <Modal isOpen={isOpen} toggle={onClose} size="md" onOpened={handleOpen} centered>
      <ModalHeader toggle={onClose}>{label || "Story"}</ModalHeader>
      <ModalBody className="text-center p-3">
        {url && !mediaError ? (
          isVideo ? (
            <video
              src={url}
              controls
              autoPlay
              style={{ maxWidth: "100%", borderRadius: 8 }}
              onError={() => setMediaError(true)}
            />
          ) : (
            <img
              src={url}
              alt="story"
              style={{ maxWidth: "100%", borderRadius: 8 }}
              onError={() => setMediaError(true)}
            />
          )
        ) : (
          <div className="py-5 text-muted">
            <p className="mb-1" style={{ fontSize: 32 }}>
              🕐
            </p>
            <p className="mb-0">Story no longer available</p>
          </div>
        )}
      </ModalBody>
    </Modal>
  );
};

export default IgStoryPopup;
